import React from "react";

const AlertModal = () => {
  return (
    <div
      className="modal fade show"
      tabIndex="-1"
      style={{
        display: "block",
        background: "rgba(0, 0, 0, 0.02)",
      }}
      aria-labelledby="exampleModalLabel"
      aria-hidden="false"
    >
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="comfirmation-content-modal">
          <div className="d-flex align-items-center justify-content-center gap-2">
            {" "}
            <i
              class="fa fa-link"
              aria-hidden="true"
              style={{ fontSize: "15px", color: "gray" }}
            ></i>
            Link Copied!{" "}
            <i
              className="fa fa-check-circle-o"
              style={{ fontSize: "15px", color: "green" }}
              aria-hidden="true"
            ></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
